import { ComponentsProps, ComponentsVariants, Theme } from "@mui/material";
import { ComponentsOverrides } from "@mui/material/styles/overrides";

type MuiLinkOverrides = {
  defaultProps?: ComponentsProps['MuiLink'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiLink'];
  variants?: ComponentsVariants['MuiLink'];
}

function getMuiLinkOverride(): MuiLinkOverrides {
  return {
    styleOverrides: {
      root: {
        "&.primary": {
           color: "var(--link-clr-primary)"
         },
        "&.secondary": {
           color: "var(--link-clr-secondary)"
         }
       }
    }
  }
}

export default getMuiLinkOverride;